define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var wbsAdminRoles = ['Calendar Administrator', 'WBS Admin'];

	csiAccess.addViewRoles({
		"WbsAdmin":{
			"HolidayCalendars":{
				"":access(full(wbsAdminRoles))
			},
			"WbsMgmt":{
				"":access(full(wbsAdminRoles))
			},
			"WbsTemplates":{
				"":access(full(wbsAdminRoles))
			}
		}
	});
});